import React from 'react';
import { Skeleton } from 'primereact/skeleton';

export const SkeletonInput = () => {
    return (
        <>
            {[...Array(6)].map((_, index) => (
                <div key={index} className='container-input'>
                    <Skeleton height="3.3rem" className="mb-2" borderRadius="16px" />
                </div>
            ))}
        </>
    );
};